// extracted by mini-css-extract-plugin
export var awardListStyle = "awards_list-module--awardListStyle--lnxEg";